import customTheme from '~/styles/theme';

export type CategoryTag =
  | 'Advocacy'
  | 'Art'
  | 'Author'
  | 'Beauty'
  | 'Comedy'
  | 'Creativity'
  | 'Dance'
  | 'DIY'
  | 'Education'
  | 'Entertainment'
  | 'Family'
  | 'Fashion'
  | 'Finance'
  | 'Fitness'
  | 'Food'
  | 'Gaming'
  | 'Home/Decor'
  | 'LGBTQ+'
  | 'Lifestyle'
  | 'Mental Health'
  | 'Music'
  | 'Pet'
  | 'Sport'
  | 'Tech'
  | 'Travel'
  | 'Wellness';

export const categoryOptions: Record<
  CategoryTag,
  { name: CategoryTag; color: string }
> = {
  Advocacy: {
    name: 'Advocacy',
    color: customTheme.colors.additionalColors.darkPurple,
  },
  Art: { name: 'Art', color: customTheme.colors.tertiary[500] },
  Author: {
    name: 'Author',
    color: customTheme.colors.additionalColors.wineRed,
  },
  Beauty: { name: 'Beauty', color: customTheme.colors.lightBlue[500] },
  Comedy: { name: 'Comedy', color: customTheme.colors.primary[300] },
  Creativity: {
    name: 'Creativity',
    color: customTheme.colors.additionalColors.salmonRed,
  },
  Dance: { name: 'Dance', color: customTheme.colors.lightBlue[700] },
  DIY: { name: 'DIY', color: customTheme.colors.lightBlue[700] },
  Education: { name: 'Education', color: customTheme.colors.primary[700] },
  Entertainment: {
    name: 'Entertainment',
    color: customTheme.colors.additionalColors.royalBlue,
  },
  Family: { name: 'Family', color: customTheme.colors.beige[700] },
  Fashion: { name: 'Fashion', color: customTheme.colors.tertiary[600] },
  Finance: {
    name: 'Finance',
    color: customTheme.colors.additionalColors.goldenBrown,
  },
  Fitness: { name: 'Fitness', color: customTheme.colors.softPink[500] },
  Food: { name: 'Food', color: customTheme.colors.success[400] },
  Gaming: { name: 'Gaming', color: customTheme.colors.secondary[300] },
  'Home/Decor': {
    name: 'Home/Decor',
    color: customTheme.colors.additionalColors.lightBlueSpecial,
  },
  'LGBTQ+': { name: 'LGBTQ+', color: customTheme.colors.softPink[600] },
  Lifestyle: { name: 'Lifestyle', color: customTheme.colors.beige[800] },
  'Mental Health': {
    name: 'Mental Health',
    color: customTheme.colors.additionalColors.darkLavender,
  },
  Music: { name: 'Music', color: customTheme.colors.secondary[500] },
  Pet: { name: 'Pet', color: customTheme.colors.primary[400] },
  Sport: { name: 'Sport', color: customTheme.colors.success[600] },
  Tech: { name: 'Tech', color: customTheme.colors.additionalColors.oldGold },
  Travel: { name: 'Travel', color: customTheme.colors.lightBlue[700] },
  Wellness: {
    name: 'Wellness',
    color: customTheme.colors.additionalColors.fuchsia,
  },
};
